module.exports = __webpack_public_path__ + "static/defender-b32b7a209dc36abc73435dca0229a06e.jpeg";